import React, { useState } from "react";
const DEFAULT_ATTRIBUTES = {
    alpha: true,
    antialias: false,
    depth: true,
    desynchronized: true,
    failIfMajorPerformanceCaveat: undefined,
    powerPreference: "default",
    premultipliedAlpha: true,
    preserveDrawingBuffer: false,
    stencil: false,
};
export function useGL({ canvasRef, webglAttributes }) {
    const [gl, setGL] = useState();
    React.useLayoutEffect(() => {
        var _a, _b;
        const canvas = canvasRef.current;
        setGL((_b = (_a = canvas === null || canvas === void 0 ? void 0 : canvas.getContext) === null || _a === void 0 ? void 0 : _a.call(canvas, "webgl2", Object.assign(Object.assign({}, DEFAULT_ATTRIBUTES), webglAttributes))) !== null && _b !== void 0 ? _b : undefined);
    }, []);
    return gl;
}
